export default __webpack_public_path__ + "static/media/image-ph-study-ranking-n-m@2x.97573b8d.webp";